module.exports = __webpack_public_path__ + "img/p4.b19ace27.png";